import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { ExternalRequisitionCreate } from '../../models/order/external-requisition/external-requisition-create';
import { ExternalRequisition, ExternalRequisitionSearchCommand } from '../../models/order/external-requisition/external-requisition';
import { getSkipperErrorHeader } from '../../utils/error-header.util';

@Injectable({
  providedIn: 'root',
})
export class ExternalRequisitionProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/external-requisition';

  public getById(id: string, skipInterceptor = false): Observable<ApiResponse<ExternalRequisition>> {
    const headers = getSkipperErrorHeader(skipInterceptor);
    return this.httpClient.get<ApiResponse<ExternalRequisition>>(`${this.baseUrl}/${id}`, { headers });
  }

  public create(body: ExternalRequisitionCreate): Observable<ApiResponse<ExternalRequisition>> {
    return this.httpClient.post<ApiResponse<ExternalRequisition>>(`${this.baseUrl}/create`, body);
  }

  public search(
    command: ExternalRequisitionSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
    needUserApproval = false,
    excludeParentRequisitions = false,
  ): Observable<ApiResponse<PaginatedApiResponse<ExternalRequisition>>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('needUserApproval', needUserApproval.toString())
      .set('excludeParentRequisitions', excludeParentRequisitions.toString());
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder !== undefined) params = params.set('sortOrder', sortOrder.toString());
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ExternalRequisition>>>(`${this.baseUrl}/search`, command, { params });
  }
}
